export default __webpack_public_path__ + "static/media/success.56f2e0fe.svg";